import AppointmentLicense from './AppointmentLicenses';
export default AppointmentLicense;
